const initNewsList = (number) => {
    function showArticles(tabIndex) {
        const articles = document.querySelectorAll(`#news-tab${tabIndex} .article`);
        articles.forEach((article, index) => {
            article.style.display = index < number ? 'block' : 'none';
        });
        checkLoadMoreButton(tabIndex);
    }

    function loadMore(tabIndex, button) {
        const articlesContainer = document.querySelector(`#news-tab${tabIndex}`);
        const hiddenArticles = Array.from(articlesContainer.querySelectorAll('.article'))
            .filter(article => article.style.display === 'none');
        hiddenArticles.slice(0, number).forEach(article => article.style.display = 'block');

        checkLoadMoreButton(tabIndex);
    }

    function checkLoadMoreButton(tabIndex) {
        const articlesContainer = document.querySelector(`#news-tab${tabIndex}`);
        const remainingHiddenArticles = Array.from(articlesContainer.querySelectorAll('.article'))
            .filter(article => article.style.display === 'none');
        const loadMoreButton = document.querySelector(`#news-tab${tabIndex} .news-load-more`);
        if (remainingHiddenArticles.length === 0) {
            loadMoreButton.style.display = 'none';
        } else {
            loadMoreButton.style.display = 'inline-flex';
        }
    }

    document.querySelectorAll('.news-tab').forEach((tab, index) => {
        const tabIndex = tab.getAttribute('data-tab-index');
        const loadMoreButton = tab.querySelector('.news-load-more');
        loadMoreButton.addEventListener('click', () => loadMore(tabIndex, loadMoreButton));
        showArticles(tabIndex);
    });

}

export default initNewsList;
